import styled from 'styled-components'
import {Form} from 'react-bootstrap'
import {ReactNode, useState} from 'react'

interface Props {
	title: string | ((year: number) => string)
	children: (selectedYear: number) => ReactNode
}

const YearSelectorCard = ({title, children}: Props) => {
	const currentYear = new Date().getFullYear()
	const [selectedYear, setSelectedYear] = useState<number>(currentYear)

	const displayTitle = typeof title === 'function' ? title(selectedYear) : title

	return (
		<Container>
			<HeaderRow>
				<Title className={'clamp-1-line'}>{displayTitle}</Title>
				<SelectorContainer>
					<Form.Select size="sm" value={selectedYear} onChange={e => setSelectedYear(Number(e.target.value))}>
						{Array.from({length: 10}, (_, i) => (
							<option key={currentYear - i} value={currentYear - i}>
								{currentYear - i}년
							</option>
						))}
					</Form.Select>
				</SelectorContainer>
			</HeaderRow>

			{children(selectedYear)}
		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;
`

const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 15px;
`

const Title = styled.h5`
	margin: 0;
	color: var(--text-color);
	font-weight: bold;
`

const SelectorContainer = styled.div`
	width: 100px;
	flex-shrink: 0;
`

export default YearSelectorCard
